var map = {
	"./counselingRecord.png": "./src/assets/schoolChangeTrend/counselingRecord.png",
	"./dynamic.png": "./src/assets/schoolChangeTrend/dynamic.png",
	"./dynamicPublishing.png": "./src/assets/schoolChangeTrend/dynamicPublishing.png",
	"./forewarning.png": "./src/assets/schoolChangeTrend/forewarning.png",
	"./happy-phiz.png": "./src/assets/schoolChangeTrend/happy-phiz.png",
	"./interveneIcon.png": "./src/assets/schoolChangeTrend/interveneIcon.png",
	"./lineChangImg.png": "./src/assets/schoolChangeTrend/lineChangImg.png",
	"./mood.png": "./src/assets/schoolChangeTrend/mood.png",
	"./more-event.png": "./src/assets/schoolChangeTrend/more-event.png",
	"./moreEvent.png": "./src/assets/schoolChangeTrend/moreEvent.png",
	"./normal-phiz.png": "./src/assets/schoolChangeTrend/normal-phiz.png",
	"./overview.png": "./src/assets/schoolChangeTrend/overview.png",
	"./position-icon.png": "./src/assets/schoolChangeTrend/position-icon.png",
	"./positionIcon.png": "./src/assets/schoolChangeTrend/positionIcon.png",
	"./psychologyReservation.png": "./src/assets/schoolChangeTrend/psychologyReservation.png",
	"./rank1.png": "./src/assets/schoolChangeTrend/rank1.png",
	"./rank2.png": "./src/assets/schoolChangeTrend/rank2.png",
	"./rank3.png": "./src/assets/schoolChangeTrend/rank3.png",
	"./unhappy-phiz.png": "./src/assets/schoolChangeTrend/unhappy-phiz.png",
	"./warn-icon.png": "./src/assets/schoolChangeTrend/warn-icon.png",
	"./warning-phiz.png": "./src/assets/schoolChangeTrend/warning-phiz.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/schoolChangeTrend sync recursive ^\\.\\/.*\\.png$";